
import moment from 'moment';

import React, { Component } from 'react';
import styled from 'styled-components';

import Layout  from 'components/Dashboard/Layout';
import { FilterProvider, FilterContext} from 'core/FilterProvider';
import { ListContext, ListProvider } from 'core/ListProvider';
import OrderListItems from './ListItems';
import OrderListHeader from './ListHeader';
import OrderListTable from './ListTable';
import OrderDetail from './Detail';
import MassChangeDrawer from 'common/MassChangeDrawer';
import OrderMassChangeForm from './MassChange/Form';
import { Drawer } from 'ui/Drawer';


const StyledLayoutContent = styled.div`
  padding: 20px 30px;
  min-height: 0;
  height: 100%;
  display: grid;
  
  @media (max-width: 1279px) {
    padding: 10px;
  }
`;

const ScrollableContent = styled.div`
  overflow-y: auto;
  overflow-x: auto;
  contain: size;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
  padding-right: 10px;
`;


export default class OrderList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isFilterDrawerOpen: false,
    };
  }

  componentDidMount() {
    document.title = 'Перевозки';
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ isFilterDrawerOpen: false });
    }
  }

  isTableView = () => {
    return this.props.location.pathname.startsWith('/order/list_table');
  };

  getPreviewId = () => {
    const match = this.props.location.pathname.match(/\/preview\/(\d+)/);
    return match ? match[1] : undefined;
  };

  getListPath = () => {
    return this.isTableView() ? '/order/list_table' : '/order';
  };

  openPreview = (item) => {
    this.props.history.push(`${this.getListPath()}/preview/${item.id}`);
  };

  closePreview = () => {
    this.props.history.push(this.getListPath());
  };

  setDateStart = (context, date) => {
    context.setFilterValue('dateStart', date ? moment(date) : moment());
  };

  toggleFilterDrawer = () => {
    this.setState({
      isFilterDrawerOpen: !this.state.isFilterDrawerOpen,
    });
  };

  render() {
    const isTable = this.isTableView();
    const previewId = this.getPreviewId();
    const listPath = this.getListPath();

    return (
      <FilterProvider
        storageKey={'OrderListDesk'}
        filterDefaults={{
          dateStart: moment()
        }}
      >
        <FilterContext.Consumer>
          {context => {
            const { filter } = context;
            const dateStart = moment(filter.dateStart);

            const layout = (listContext) => (
              <Layout
                rows={'auto 1fr'}
              >
                <OrderListHeader
                  view={isTable ? 'table' : 'calendar'}
                  history={this.props.history}
                  filter={filter}
                  onDateChange={(value) => this.setDateStart(context, value)}
                  onSearchChange={(value) => context.setFilterValue('search', value)}
                  onFiltersClick={this.toggleFilterDrawer}
                  extra={listContext ? (
                    <MassChangeDrawer listContext={listContext} FormComponent={OrderMassChangeForm} />
                  ) : null}
                />

                {isTable ? (
                  <OrderListTable
                    isFilterDrawerOpen={this.state.isFilterDrawerOpen}
                    onCloseFilters={this.toggleFilterDrawer}
                    previewId={previewId}
                    listPath={listPath}
                    onPreview={this.openPreview}
                    onClosePreview={this.closePreview}
                  />
                ) : (
                  <StyledLayoutContent>
                    <ScrollableContent>
                      <div>
                        <OrderListItems
                          key={dateStart.format('YYYY-MM-DD')}
                          date={dateStart}
                          searchPhrase={filter.search}
                          previewId={previewId}
                          listPath={listPath}
                          onPreview={this.openPreview}
                          onClosePreview={this.closePreview}
                        />
                        <OrderListItems
                          date={null}
                          searchPhrase={filter.search}
                          lazy={true}
                          pageSize={20}
                          previewId={previewId}
                          listPath={listPath}
                          onPreview={this.openPreview}
                          onClosePreview={this.closePreview}
                        />
                      </div>
                    </ScrollableContent>
                  </StyledLayoutContent>
                )}

                <Drawer
                  open={!!previewId}
                  onClose={this.closePreview}
                  width={'450px'}
                  disableEscapeKeyDown={true}
                >
                  <OrderDetail
                    id={previewId}
                    onClose={this.closePreview}
                    fromPath={`${listPath}/preview/${previewId}`}
                  />
                </Drawer>
              </Layout>
            );

            if (isTable) {
              return (
                <ListProvider
                  url={'order'}
                  filterInitial={{
                    page_size: 15
                  }}
                  removeFilter={['date']}
                  storageKey={'ListProvider-orders-table-view'}
                >
                  <ListContext.Consumer>
                    {listContext => layout(listContext)}
                  </ListContext.Consumer>
                </ListProvider>
              );
            }

            return layout(null);
          }}
        </FilterContext.Consumer>
      </FilterProvider>
    );
  }
}
